import type {ShellSurface} from '@wandb/forge-shell-contract';

import {parseHttpUrl} from './httpUrl';

const SURFACES = [
  'forge',
  'identity',
] as const satisfies readonly ShellSurface[];
export type Surface = ShellSurface;

export const isSurface = (value: unknown): value is Surface =>
  typeof value === 'string' && (SURFACES as readonly string[]).includes(value);

export function resolveSurface(
  origin: string,
  origins?: Partial<Record<Surface, string>>
): Surface {
  const served = parseHttpUrl(origin);
  if (!served) {
    return 'forge';
  }

  for (const [surface, configuredOrigin] of Object.entries(origins ?? {})) {
    if (!isSurface(surface) || configuredOrigin === undefined) {
      continue;
    }
    if (parseHttpUrl(configuredOrigin)?.origin === served.origin) {
      return surface;
    }
  }

  return 'forge';
}
